module.exports = __webpack_public_path__ + "files/5a42425b1a1c89dd87bb08127b3bce26.svg";